/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Download_All_ErrorInputs */

const en_doc_download_all_error = /** @type {(inputs: Doc_Download_All_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not download one or more files.`)
};

const pt_br2_doc_download_all_error = /** @type {(inputs: Doc_Download_All_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível baixar um ou mais arquivos.`)
};

/**
* | output |
* | --- |
* | "Could not download one or more files." |
*
* @param {Doc_Download_All_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_download_all_error = /** @type {((inputs?: Doc_Download_All_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Download_All_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_download_all_error(inputs)
	return pt_br2_doc_download_all_error(inputs)
});